var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityNonMains40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.5029H8.12209",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4229 11.5029H30.5289C31.274 11.5029 31.878 12.0635 31.878 12.7551V28.2508C31.878 28.9423 31.274 29.5029 30.5289 29.5029H21.4229C16.9525 29.5029 13.3286 26.1392 13.3286 21.9899V19.016C13.3286 14.8666 16.9525 11.5029 21.4229 11.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8706 17.515L25.7412 20.2885L22.8706 23.0621L20 20.2885L22.8706 17.515Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8779 16.5029H35.2291C35.6549 16.5029 36 16.9506 36 17.5029C36 18.0552 35.6549 18.5029 35.2291 18.5029H31.8779V16.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8779 22.5029H35.2291C35.6549 22.5029 36 22.9506 36 23.5029C36 24.0552 35.6549 24.5029 35.2291 24.5029H31.8779V22.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7386 16.5029H8.12207V24.5029H13.7386C13.4382 23.7172 13.2747 22.8712 13.2747 21.9899V19.016C13.2747 18.1346 13.4382 17.2887 13.7386 16.5029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12207 16.5029V15.9529H7.57207V16.5029H8.12207ZM13.7386 16.5029L14.2523 16.6993L14.5377 15.9529H13.7386V16.5029ZM8.12207 24.5029H7.57207V25.0529H8.12207V24.5029ZM13.7386 24.5029V25.0529H14.5377L14.2523 24.3065L13.7386 24.5029ZM8.12207 17.0529H13.7386V15.9529H8.12207V17.0529ZM8.67207 24.5029V16.5029H7.57207V24.5029H8.67207ZM13.7386 23.9529H8.12207V25.0529H13.7386V23.9529ZM14.2523 24.3065C13.9753 23.582 13.8247 22.8026 13.8247 21.9899H12.7247C12.7247 22.9399 12.901 23.8523 13.2249 24.6993L14.2523 24.3065ZM13.8247 21.9899V19.016H12.7247V21.9899H13.8247ZM13.8247 19.016C13.8247 18.2033 13.9753 17.4238 14.2523 16.6993L13.2249 16.3065C12.901 17.1535 12.7247 18.0659 12.7247 19.016H13.8247Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityNonMains40);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityNonMains40.4f2e8aeeebf36fe45ef89861c94f7c40.svg";
export { ForwardRef as ReactComponent };